/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UssdBankRecord } from './UssdBankRecord';

/**
 * Class used to define the bank chosen for the USSD payment
 */
export type PayOnlyOperationReqUssdDTO = {
    /**
     * Amount to pay
     */
    amount: number;
    /**
     * Currency of the operation
     */
    currency: PayOnlyOperationReqUssdDTO.currency;
    /**
     * Description given by the merchant about the payment collection
     */
    description?: string;
    ussdBank: UssdBankRecord;
};

export namespace PayOnlyOperationReqUssdDTO {

    /**
     * Currency of the operation
     */
    export enum currency {
        GHS = 'GHS',
        NGN = 'NGN',
    }


}
